module.exports = __webpack_public_path__ + "6ab6172d15da7da5a76f7036fd826403.png";